import { Theft } from './theft'

export const AssetsProtectionTheft = () => {
    return <Theft />
}
